import { required, minLength, maxLength, email } from 'vuelidate/lib/validators';

export const validations = () => ({
    formData: {
        first_name: { required, min_length: minLength(2), max_length: maxLength(30) },
        last_name: { required, min_length: minLength(2), max_length: maxLength(40) },
        government_id: { required, min_length: minLength(5), max_length: maxLength(15) },
        // 15 y no 16: la columna `phone` de bank_accounts es varchar(15) y la
        // API valida max:15. Con 16 el formulario dejaba escribir un teléfono
        // que después la API rechazaba con un 422 ilegible.
        phone: { min_length: minLength(6), max_length: maxLength(15) },
        email: { email },
        bank_account_number: { required },
        bank_code: { required },
        bank_name: { required },
        bank_address: { max_length: maxLength(150) },
        branch_code: { max_length: maxLength(50) },
        message: { max_length: maxLength(255) }
    }
});